module.exports = __webpack_public_path__ + "images/boatyard_logo_worthwhile.e1711724a7c93f6316d247836424c08f.png";